export default "__VITE_ASSET__pnq1tMSb__"